import { Button } from "@/design-system/components/Button/Button";
import { colors } from "@material-ui/core";
import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { GoogleOAuthConfigModal } from "../../modals/GoogleOAuthConfigModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { GoogleCampaignManager360Icon } from "../../../components/icons/themes/logos";

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  return (
    <ConfigureDestinationsModal
      limitSettings={["profileId", "advertiserId"]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idsSet = "profileId" in settings && "advertiserId" in settings;

  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={idsSet ? "" : colors.red[600]}
      labelText={idsSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  // only show the oauth flow if we're in server side mode
  var enable_row = existingConfig.connection_mode !== "server" ? true : false;

  // this comes from the google app verification process. They want links that
  // say Google Ads, to also have the icon. But also not show the icon alone
  // afaict. So we show <icon> Connect with Google if oauth is not configured.
  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#4285F4]"
      leadingIcon={
        !oauthConfigured && <GoogleCampaignManager360Icon className="h-4 w-4" />
      }
      onClick={setConfigModalOpen}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Google CM360"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      disabled={enable_row}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CONFIG = "CONFIG";
const OAUTH = "OAUTH";

const Rows = {
  [CONFIG]: ConfigurationRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CONFIG]: ConfigurationModal,
  [OAUTH]: GoogleOAuthConfigModal,
};

const RowOrder = [CONFIG, OAUTH];

export default {
  Rows,
  RowOrder,
  Modals,
};
